import advanceAjaxTableInit from '../theme/advance-ajax-table';

const { docReady } = window.phoenix.utils;

docReady(advanceAjaxTableInit);
